export default "__VITE_ASSET__BuiTxh3y__"